import { useEffect } from "react";

const StructuredData = () => {
  useEffect(() => {
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Locksmith",
      "name": "Tolstoï Serrurier",
      "image": "https://www.tolstoi-serrurier.fr/logo.jpg",
      "url": "https://www.tolstoi-serrurier.fr",
      "telephone": "+33482531608",
      "email": "serruriertolstoi@gmail.com",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "Zone d'intervention 69/01",
        "addressLocality": "Villeurbanne",
        "postalCode": "69100",
        "addressCountry": "FR"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": "45.7667",
        "longitude": "4.8833"
      },
      "openingHoursSpecification": {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": [
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
          "Sunday"
        ],
        "opens": "00:00",
        "closes": "23:59"
      },
      "priceRange": "€€",
      "areaServed": [
        {
          "@type": "City",
          "name": "Villeurbanne"
        },
        {
          "@type": "City",
          "name": "Lyon"
        },
        {
          "@type": "City",
          "name": "Bron"
        },
        {
          "@type": "City",
          "name": "Caluire-et-Cuire"
        },
        {
          "@type": "City",
          "name": "Vaulx-en-Velin"
        },
        {
          "@type": "City",
          "name": "Vénissieux"
        }
      ],
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "Services de serrurerie",
        "itemListElement": [
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Ouverture de porte d'urgence",
              "description": "Ouverture de porte claquée ou fermée à clé, intervention sans casse"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Changement de serrure",
              "description": "Remplacement de tous types de serrures : cylindre, multipoints, encastrée"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Réparation de serrure",
              "description": "Réparation de serrure endommagée, cylindre grippé ou cassé"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Installation volet roulant",
              "description": "Dépannage, installation et réparation de volets roulants"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Porte blindée et garage",
              "description": "Installation de portes blindées et portes de garage"
            }
          }
        ]
      }
    });
    document.head.appendChild(script);

    return () => {
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
    };
  }, []);

  return null;
};

export default StructuredData;
